// Fix for Safari Mobile & Responsive Design
export const initialSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});
